import React from 'react'
import { useNavigate } from 'react-router-dom'

const LogoHeader = () => {
  const navigate = useNavigate()
  return (
    <div style={{ cursor: 'pointer' }} onClick={() => navigate('/')}>
      <img src="/ekonsteam.png" alt="logo" className="logo" width={250} />
    </div>
  )
}

export default LogoHeader
